import { LineSegments, Material, Object3D, Vector3 } from 'three';
import { ILayerElement } from './i-layer-element';
import { SimpleTextValueVO } from '@shared/vo/meta-element.vo';
import { LabelElement } from './label-element';
import { DimensionUtils } from '../util/dimension.utils';

export class RulerElement extends Object3D implements ILayerElement {

  public static readonly LINE_COLOR: number = 0x000000;
  public static readonly LINE_LENGTH: number = 30;
  public static readonly LABEL_FONT_SIZE: number = 10;
  public static readonly LABEL_OFFSET: number = 20;

  public layerElementType: string = 'ILayerElement';

  private elementPosition: Vector3;

  constructor(position: Vector3, textValue: SimpleTextValueVO) {
    super();
    this.elementPosition = position;
    this.createLabel(textValue);
    this.createLine();
  }

  protected createLabel(textValue: SimpleTextValueVO): void {
    const labelLength: number = DimensionUtils.getTextWidth(textValue, RulerElement.LABEL_FONT_SIZE);
    const label: LabelElement = new LabelElement(textValue, RulerElement.LABEL_FONT_SIZE, LabelElement.DEFAULT_ROTATION, labelLength);
    (label.material as Material).depthTest = true;
    label.renderOrder = 1;
    label.position.set(this.elementPosition.x, this.elementPosition.y, this.elementPosition.z + RulerElement.LINE_LENGTH / 2 + RulerElement.LABEL_OFFSET);
    this.add(label);
  }

  protected createLine(): void {
    const lines: Object3D = new Object3D();
    const startPoint: Vector3 = this.elementPosition.clone().add(new Vector3(0, 0, -RulerElement.LINE_LENGTH / 2));
    const endPoint: Vector3 = this.elementPosition.clone().add(new Vector3(0, 0, RulerElement.LINE_LENGTH / 2));
    const lineTo: LineSegments = DimensionUtils.createLineSegment(startPoint, endPoint, RulerElement.LINE_COLOR);
    lines.add(lineTo);
    this.add(lines);
  }
}
